import MandatePayroll from '../entities/MandatePayroll';
import MandatesPayrollResponseDTO from '../entities/MandatesPayrollResponseDTO';

const PayrollAuthorizationResponseDTOtoPayrollAuthorizationAdapter = (
  response: MandatesPayrollResponseDTO,
): MandatePayroll[] => {
  if (!response.body) {
    throw Error();
  }

  return response.body.mandateResponseList.map(
    payrollAuthorization =>
      new MandatePayroll(
        payrollAuthorization.status,
        payrollAuthorization.fromAccount,
        payrollAuthorization.username,
        payrollAuthorization.userId,
        payrollAuthorization.postingDate,
        payrollAuthorization.amount,
        payrollAuthorization.currency,
        payrollAuthorization.referenceNumber,
        payrollAuthorization.beneficiaryName,
        payrollAuthorization.accountId,
        payrollAuthorization.orderDirection,
        payrollAuthorization.globalOrderId,
        payrollAuthorization.orderMessageType,
        payrollAuthorization.accountNumber,
        payrollAuthorization.customerId,
        payrollAuthorization.orderProcessType,
        payrollAuthorization.processStatus,
        payrollAuthorization.fileType,
        payrollAuthorization.fileName,
        payrollAuthorization.payrollFileId,
      ),
  );
};

export { PayrollAuthorizationResponseDTOtoPayrollAuthorizationAdapter };
